export default __webpack_public_path__ + "static/media/flag-gb.eeb8cd95.svg";